<!--
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Date: 23/07/29
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/30
 * @FilePath: /app_list/src/App.vue
 * @Description: 展示各个 app 的信息及下载链接
 * 
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved. 
-->
<template>
  <div>
    <RouterView></RouterView>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
onMounted(() => {
  router.push({ path: '/' })
})
</script>

<style></style>
